import { render, staticRenderFns } from "./adCate.vue?vue&type=template&id=553251d4&scoped=true"
import script from "./adCate.vue?vue&type=script&lang=js"
export * from "./adCate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553251d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/deduct_saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('553251d4')) {
      api.createRecord('553251d4', component.options)
    } else {
      api.reload('553251d4', component.options)
    }
    module.hot.accept("./adCate.vue?vue&type=template&id=553251d4&scoped=true", function () {
      api.rerender('553251d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ad/adCate.vue"
export default component.exports